import { render, staticRenderFns } from "./ProductOrService.vue?vue&type=template&id=a47a382c&"
import script from "./ProductOrService.vue?vue&type=script&lang=js&"
export * from "./ProductOrService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports